import { TrashIcon } from "@heroicons/react/24/outline";
import fetch from "cross-fetch";
import { useCallback } from "react";
import { mutate } from "swr";
import useApiKeys from "@/components/context/useApiKeys";
import { ApiKey } from "@/components/models/ApiKey";
import { Button } from "@/components/ui/Button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/Table";
import { formatDistanceToNow } from "date-fns";

export default function ApiKeysList() {
  const { apiKeys } = useApiKeys();

  const deleteClicked = useCallback((apiKey: ApiKey) => {
    if (confirm(`Are you sure? API Key "${apiKey.name}" will be deleted.`)) {
      fetch(`/web_api/api_keys/${apiKey.id}`, {
        method: "DELETE",
      })
        .then((resp) => resp.json())
        .then((json) => {
          if (json.status === "ok") {
            mutate("/web_api/api_keys");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, []);

  if (apiKeys.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>No API keys yet. Create one to get started.</p>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>API Key</TableHead>
            <TableHead>Created</TableHead>
            <TableHead>Last Used</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {apiKeys.map((apiKey) => (
            <TableRow key={apiKey.id}>
              <TableCell className="font-medium">{apiKey.name}</TableCell>
              <TableCell>
                <code className="text-sm bg-muted px-2 py-1 rounded font-mono">{apiKey.key}</code>
              </TableCell>
              <TableCell className="text-muted-foreground">
                {formatDistanceToNow(new Date(apiKey.created_at), {
                  addSuffix: true,
                })}
              </TableCell>
              <TableCell className="text-muted-foreground">
                {apiKey.last_used_at
                  ? formatDistanceToNow(new Date(apiKey.last_used_at), {
                      addSuffix: true,
                    })
                  : "Never"}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => deleteClicked(apiKey)}
                  className="text-destructive hover:text-destructive"
                >
                  <TrashIcon className="h-4 w-4" />
                  <span className="sr-only">Delete API Key {apiKey.name}</span>
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
